import React from "react";
import styles from "./switcher_cat_prod.module.css";

function SwitcherCatProd ({
  checkProd, handleChecked, visible = true
}) {


  return (
    <div className={`${styles.checkbox} ${!visible && styles.checkbox__hidden}`}>
      <label className={`${styles.label}`}>
        <input
          className={`${styles.button}`}
          type="checkbox"
          checked={checkProd}
          onChange={handleChecked}
        />
        <p className={`${styles.text} ${!checkProd && styles.textWhite}`}>Подкатегории</p>
        <p className={`${styles.text} ${checkProd && styles.textWhite}`}>Товары</p>

      </label>
    </div>
  );
}

export default SwitcherCatProd;
